define('v3/Common/Components/Grid/Grid.Component',[
	'knockout',
	'lodash',
	'v3/Common/Models/enums',
	'v3/Common/Helpers/Sort/Sort.Helper',
	'text!v3/Common/Components/Grid/Grid.Component.html',
	'knockout-sortable',
	'v3/Common/Bindings/Mask.Binding',
	'v3/Common/Bindings/EmptyPlaceholder.Binding'
], function (ko, _, enums, SortHelper, htmlString) {
	function GridViewModel (params) {
		var self = this;

		self.enums = enums;
		self.columns = params.columns || [];
		self.afterRow = params.afterRow || false;
		self.toggleExtraRow = params.toggleExtraRow || false;
		self.data = params.data;
		self.rowVisible = params.rowVisible;
		self.metaData = params.metaData;
		self.isDnDmode = !!params.dragAndDrop;
		self.bindingCSS = params.bindingCSS || {};

		if (self.isDnDmode) {
			if (typeof params.dragAndDrop.afterMove !== 'function') {
				throw new Error('afterMove function is expected in params.dragAndDrop');
			}

			self.sortedData = self.data;
			self.bindingOptions = params.dragAndDrop.options || {};
			self.afterMoveCallback = params.dragAndDrop.afterMove;

			if (typeof params.dragAndDrop.beforeMove === 'function') {
				self.beforeMoveCallback = params.dragAndDrop.beforeMove;
			} else {
				self.beforeMoveCallback = function () {};
			}
		} else {
			self.sortBy = params.sortBy || ko.observable('');
			self.sortDirection = params.sortDirection || ko.observable('');
			self.sortedData = new SortHelper(self.sortBy, self.sortDirection, self.data, self.columns);
			self.bindingOptions = {};
		}

		self.isLoading = (self.data && self.data.isLoading) || params.isLoading || ko.observable(false);
		self.canShowEmptyPlaceholder = params.emptyPlaceholder || false;

		if (params.toggleExtraRow) {
			self.toggleComputed = ko.computed(function () {
				var data = ko.unwrap(self.sortedData);

				return _.forEach(data, function (d) {
					if (d.sorting && !_.isArray(d.sorting)) {
						d.sorting = [d.sorting];
					}
					if (!d.toggleExtraRowActive) {
						d.toggleExtraRowActive = ko.observable(false);
					}
					return d;
				});
			});
		}

		self.getClassName = function ($data, $index, isHeader) {
			var classNames;

			if ($data && $data.template && !$data.className) {
				classNames = $data.template;
			} else {
				classNames = $data.className || 'grid-unnamed-col-' + $index();
			}

			if ($data && $data.sorting && $data.sorting.length > 0) {
				classNames += ' sortable';
			}

			if (isHeader && $data.headerClassName) {
				classNames += ' ' + $data.headerClassName;
			}

			return classNames;
		};

		self.sort = function ($data) {
			if ($data && $data.sorting && !self.isLoading()) {
				self.sortedData.sortBy($data);
			}
		};

		self.visibleColumns = function (columns) {
			return _.filter(columns, function (data) {
				return _.isNil(data.visible) || ko.unwrap(data.visible);
			}) || 0;
		};

		self.hasHeaders = function (columns) {
			return _.filter(self.visibleColumns(columns), function (data) {
				return !!(data.header);
			}) || 0;
		};

		self.hasSortables = function (columns) {
			return _.filter(self.visibleColumns(columns), function (data) {
				return (data && data.sorting && data.sorting.length > 0);
			}) || 0;
		};

		self.isActiveKey = function ($data) {
			if ($data) {
				return self.sortedData.isActiveKey($data);
			}
		};

		self.toggle = function (currentData) {
			_.each(self.sortedData(), function (obj) {
				if (obj && obj !== currentData) {
					if (obj.toggleExtraRowActive && ko.isObservable(obj.toggleExtraRowActive)) {
						if (obj.toggleExtraRowActive()) {
							obj.toggleExtraRowActive(false);
							if (params.toggleExtraRow.callbacks && params.toggleExtraRow.callbacks.onDeselect) {
								params.toggleExtraRow.callbacks.onDeselect(obj);
							}
						}
					}
				}
			});

			currentData.toggleExtraRowActive(!currentData.toggleExtraRowActive());
			if (currentData.toggleExtraRowActive()) {
				var tmpData = _.extend({}, currentData);
				delete tmpData.toggleExtraRowActive;

				if (params.toggleExtraRow.callbacks && params.toggleExtraRow.callbacks.onSelect) {
					params.toggleExtraRow.callbacks.onSelect(tmpData);
				}
			} else {
				if (params.toggleExtraRow.callbacks && params.toggleExtraRow.callbacks.onDeselect) {
					params.toggleExtraRow.callbacks.onDeselect(currentData);
				}
			}
		};

		self.dispose = function () {
			if (self.toggleComputed && self.toggleComputed.dispose) {
				self.toggleComputed.dispose();
			}
		};
	}

	GridViewModel.prototype.afterMove = function (arg) {
		this.afterMoveCallback(arg, this.metaData);
	};
	GridViewModel.prototype.beforeMove = function (arg) {
		this.beforeMoveCallback(arg, this.metaData);
	};

	return { viewModel: GridViewModel, template: htmlString };
});
